/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NavigationService {
    /**
     * @param clockStationId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiNavigationSaved(
        clockStationId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Navigation/{clockStationId}/saved',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
}
